import $ from "jquery"
import TemplateView from "../../TemplateView"
import AddNewButton from "../AddNewButton"
import SearchField from "../SearchField"
import messageResource from "../../messageResource"
import Tree from "./tree/Tree"
import CustomerStore from "../../store/CustomerStore"
import ProjectStore from "../../store/ProjectStore"
import CPReportSelector from "../../cp_selector/cp_selector_report_config"
import {connect} from "../../redux/utils"
import {
    getCustomerProjectNameFilter,
    getFilterCPSelection,
    getEditableCustomerIds,
    getEditableProjectIds,
    getRecentlyCreatedCustomerIds,
    getRecentlyCreatedProjectIds,
    getSingleCPSelection,
    isPossibleToAddCustomers,
    isPossibleToAddProjects,
    isViewerHasAccessToAllManagementScope,
    isCPPanelClosed,
    isPossibleToAddTasks,
} from "../common/selectors"
import {getOpenCustomerId} from '../../panels/customer/selectors'
import {getOpenProjectId} from '../../panels/project/selectors'
import Button from '../../components/Button'
import {bindActionCreators} from 'redux'
import {collapsePanel, expandPanel} from '../common/actions'
import {getCollapsedCustomersSet, getCPPanelMaxWidth, getCPPanelMinWidth, getCPPanelWidth, getIsCustomersAsc} from './selectors'
import {addCollapsedCustomers, removeCollapsedCustomers, setCpPanelWidth, changeVisibleCustomerIds, changeVisibleProjectIds, changeIsCustomersAsc} from './actions'
import {LEFT_MIN_WIDTH} from './constants'
import {changeCustomerProjectNameFilter, changeFilterCPSelectionAction, changeSingleCPSelectionAction } from '../common/actions'
import CustomerProjectSelection from '../../CustomerProjectSelection'
import {getCustomers, getProjects} from '../../entities/selectors'
import AddNewMenu from './AddNewMenu'
import ExportCPDropdown from './ExportCPDropdown'
import {CustomersProjectsSelectionQualifier} from 'constants'

class CustomersProjectsPanel extends TemplateView{
    constructor({
        importTasksCb = () => {},
        createNewTasksCb = () => {},
        createNewProjectCb = () => {},
        createNewCustomerCb = () => {},
        changeFilterCPSelection = () => {},
        changeSingleCPSelection = () => {},
        changeNameFilter = () => {},
        expandPanel = () => {},
        collapsePanel = () => {},
        setWidth = () => {},
        addCollapsedCustomers = () => {},
        removeCollapsedCustomers = () => {},
        changeVisibleCustomerIds = () => {},
        changeVisibleProjectIds = () => {},
        changeIsCustomersAsc = () => {}
    } = {}) {
        super(null)

        this.actions = {
            changeFilterCPSelection,
            changeSingleCPSelection,
            changeNameFilter,
            expandPanel,
            collapsePanel,
            setWidth,
            addCollapsedCustomers,
            removeCollapsedCustomers,
            changeVisibleProjectIds,
            changeVisibleCustomerIds,
            changeIsCustomersAsc
        }

        this.callbacks = {
            importTasksCb,
            createNewTasksCb,
            createNewProjectCb,
            createNewCustomerCb,
        }

        this.state = {
            isPossibleToAddCustomers: false,
            isPossibleToAddProjects: false,
            isPossibleToAddTasks: false,
            editableCustomerIds: {},
            editableProjectIds: {},
            isCustomersAsc: true,
            singleCustomerProjectSelection: {},
            filterCustomerProjectSelection: {},
            customers: {},
            projects: {},
            nameFilter: '',
            editingCustomerId: null,
            editingProjectId: null,
            recentlyCreatedCustomerIds: [],
            recentlyCreatedProjectIds: [],
            cpPanelClosed: false,
            resizableMaxWidth: 0,
            resizableMinWidth: LEFT_MIN_WIDTH,
            width: 0,
            collapsedCustomersSet: {},
        }

        this.onStatePropertyChanged('isCustomersAsc', isCustomersAsc => this.tree.setState({isCustomersAsc}))
        this.onStatePropertyChanged('editableCustomerIds', editableCustomerIds => this.tree.setState({editableCustomerIds}))
        this.onStatePropertyChanged('editableProjectIds', editableProjectIds => this.tree.setState({editableProjectIds}))
        this.onAnyStatePropertyChanged(['filterCustomerProjectSelection', 'customers', 'projects'], () => this._updateCpSelector())

        this.onStateChanged(state => this.tree.setState({
                nameFilter: state.nameFilter,
                singleCustomerProjectSelection: state.singleCustomerProjectSelection,
                filterCustomerProjectSelection: state.filterCustomerProjectSelection,
                customers: state.customers,
                projects: state.projects,
                editableCustomerIds: state.editableCustomerIds,
                editableProjectIds: state.editableProjectIds,
                editingCustomerId: state.editingCustomerId,
                editingProjectId: state.editingProjectId,
                recentlyCreatedCustomerIds: state.recentlyCreatedCustomerIds,
                recentlyCreatedProjectIds: state.recentlyCreatedProjectIds,
                collapsedCustomersSet: state.collapsedCustomersSet,
            })
        )

        this.onStatePropertyChanged('cpPanelClosed', (closed) => closed ? this._collapse() : this._expand())
        this.onStatePropertyChanged('resizableMaxWidth', maxWidth => {
            this.$containerEl.resizable("option", "maxWidth", maxWidth)
            this._updateWidth()
        })

        this.onStatePropertyChanged('resizableMinWidth', minWidth => this.$containerEl.resizable("option", "minWidth", minWidth))
        this.onStatePropertyChanged('width', width => {
            this.$containerEl.width(width)
            this.tree.adjustSize()
        })

        this.onStatePropertyChanged('isPossibleToAddTasks', show => this.addNewButton.toggle(show))

        this.onAnyStatePropertyChanged([
            'isPossibleToAddProjects',
            'isPossibleToAddCustomers',
        ], ({isPossibleToAddProjects, isPossibleToAddCustomers}) => {
            this.addNewCustomerProjectMenu.setState({isPossibleToAddProjects, isPossibleToAddCustomers})
        })
    }

    templateHtml(){
        return "<div class='customersProjectsPanel'>" +
               "  <div class='header'>" +
               "    <div class='titleContainer'>" +
               "        <div class='collapseButtonPlaceholder'></div>" +
               "        <div class='title'><%-customers_and_projects%></div>" +
               "        <div class='addNewContainer'></div>" +
               "    </div>" +
               "    <div class='searchAndExportContainer'>" +
               "        <div class='searchFieldContainer'></div>" +
               "    </div>" +
               "  </div>" +
               "  <div class='customersProjectsTreeContainer'></div>" +
               "  <div class='collapsedContainer'>" +
               "    <div class='expandButtonPlaceholder'></div>" +
               "    <div class='title'><%-customers_and_projects%></div>" +
               "  </div>" +
               "</div>";
    }

    templateModel()
    {
        return {
            customers_and_projects: messageResource.getMessage("projects_customers_selector.customers_and_projects")
        }
    }

    afterRender()
    {
        const buttonsContainer = this.find(".addNewContainer")
        this._createAddNewButtons(buttonsContainer)

        new SearchField({
            onFieldChange: (text) => this.actions.changeNameFilter(text.trim())
        }).init(this.find(".searchFieldContainer"));

        new Button({
            additionalClass: "collapseCPPanelButton",
            onClickCb: () => this.actions.collapsePanel(),
        }).init(this.find(".collapseButtonPlaceholder"))

        new Button({
            additionalClass: "expandCPPanelButton",
            onClickCb: () => this.actions.expandPanel(),
        }).init(this.find(".collapsedContainer .expandButtonPlaceholder"))

        this.tree = new Tree({
            onSingleCPSelectionChanged: this.actions.changeSingleCPSelection,
            addCollapsedCustomers: this.actions.addCollapsedCustomers,
            removeCollapsedCustomers: this.actions.removeCollapsedCustomers,
            onVisibleCustomerIdsChanged: this.actions.changeVisibleCustomerIds,
            onVisibleProjectIdsChanged: this.actions.changeVisibleProjectIds,
            onIsCustomersAscChanged: this.actions.changeIsCustomersAsc,
        }).init(this.find(".customersProjectsTreeContainer"));

        this.exportCPDropdown = new ExportCPDropdown().init(this.find(".searchAndExportContainer"))

        this.$containerEl.resizable({
            handles: 'e',
            stop: (event, ui) => {
                this.actions.setWidth(ui.element.width())
                // Remove unwanted side-effect of jQuery UI resizable
                ui.element.css("height", "")
            }
        });
    }

    _collapse() {
        this.$containerEl.addClass('collapsed')
        this.$containerEl.resizable('disable')
    }

    _expand() {
        this.$containerEl.removeClass('collapsed')
        this.$containerEl.resizable('enable')
        this._updateWidth()
    }

    _updateWidth() {
        if (this.$containerEl.width() > this.state.resizableMaxWidth)
            this.actions.setWidth(this.state.resizableMaxWidth)
    }

    _createAddNewButtons() {
        this.addNewCustomerProjectMenu = new AddNewMenu({
            importTasksCb: this.callbacks.importTasksCb,
            createNewTasksCb: this.callbacks.createNewTasksCb,
            createNewProjectCb: this.callbacks.createNewProjectCb,
            createNewCustomerCb: this.callbacks.createNewCustomerCb,
        }).init($("body"))

        this.addNewButton = new AddNewButton({
            title: messageResource.getMessage('task.list.add_new'),
            menu: this.addNewCustomerProjectMenu,
        }).init(this.find(".addNewContainer"))
    }

    _updateCpSelector()
    {
        $("#customersProjectsPanelFilterCPSelectorContainer").empty();

        this.cpSelector = new CPReportSelector({showEmptyCustomers: true});
        this.cpSelector.init(this.state.filterCustomerProjectSelection,
                             "customersProjectsPanelFilterCPSelectorContainer",
                             () => {
                                 const cpSelection = this.cpSelector.getCpSelection()
                                 if (CustomerProjectSelection.fromPlainObject(cpSelection).isEmpty()) {
                                     this.cpSelector.resetSelection()
                                 }
                                 this.actions.changeFilterCPSelection(cpSelection)
                             });
        this.cpSelector.initializeData({
                                           customers: CustomerStore.getAll(),
                                           projects: ProjectStore.getAll()
                                       });


        this.tree.setState({
            cpSelectorFiltered: this.state.filterCustomerProjectSelection.qualifier !== CustomersProjectsSelectionQualifier.ALL,
        })

        this.cpSelector.getButton().on("menuhide", () => {
            this.tree.setState({
                cpSelectorOpened: false,
            })
        })
        this.cpSelector.getButton().on("menushow", () => {
            this.tree.setState({
                cpSelectorOpened: true,
            })
        })
    }
}

export default connect(
    (state) => ({
        canAccessAllScope: isViewerHasAccessToAllManagementScope(state),
        isPossibleToAddTasks: isPossibleToAddTasks(state),
        isPossibleToAddCustomers: isPossibleToAddCustomers(state),
        isPossibleToAddProjects: isPossibleToAddProjects(state),
        editableCustomerIds: getEditableCustomerIds(state),
        editableProjectIds: getEditableProjectIds(state),
        isCustomersAsc: getIsCustomersAsc(state),
        singleCustomerProjectSelection: getSingleCPSelection(state),
        filterCustomerProjectSelection: getFilterCPSelection(state),
        customers: getCustomers(state),
        projects: getProjects(state),
        nameFilter: getCustomerProjectNameFilter(state),
        editingCustomerId: getOpenCustomerId(state),
        editingProjectId: getOpenProjectId(state),
        recentlyCreatedCustomerIds: getRecentlyCreatedCustomerIds(state),
        recentlyCreatedProjectIds: getRecentlyCreatedProjectIds(state),
        cpPanelClosed: isCPPanelClosed(state),
        resizableMaxWidth: getCPPanelMaxWidth(state),
        resizableMinWidth: getCPPanelMinWidth(state),
        width: getCPPanelWidth(state),
        collapsedCustomersSet: getCollapsedCustomersSet(state),
    }),
    dispatch => ({
        changeFilterCPSelection: bindActionCreators(changeFilterCPSelectionAction, dispatch),
        changeSingleCPSelection: bindActionCreators(changeSingleCPSelectionAction, dispatch),
        changeNameFilter: bindActionCreators(changeCustomerProjectNameFilter, dispatch),
        expandPanel : bindActionCreators(expandPanel, dispatch),
        collapsePanel: bindActionCreators(collapsePanel, dispatch),
        setWidth: bindActionCreators(setCpPanelWidth, dispatch),
        addCollapsedCustomers: bindActionCreators(addCollapsedCustomers, dispatch),
        removeCollapsedCustomers: bindActionCreators(removeCollapsedCustomers, dispatch),
        changeVisibleCustomerIds: bindActionCreators(changeVisibleCustomerIds, dispatch),
        changeVisibleProjectIds: bindActionCreators(changeVisibleProjectIds, dispatch),
        changeIsCustomersAsc: bindActionCreators(changeIsCustomersAsc, dispatch)
    })
)(CustomersProjectsPanel)



// WEBPACK FOOTER //
// ./web/js/taskManagement/customersProjectsPanel/CustomersProjectsPanel.js